module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABFElEQVR4AWOgC7CqPYeMTCrPGFecMSwDkZY1KFIIDRY15yxhqrPm3jpw9f2aE69SZ940qz5rWH7GGk0D0Bi31oumlWeBRgJ1Pnrz4z8MnLn7qWjRHaApKBqMK89kz7216OALx6YLBQtv//337z8SuPDgC8htaDaYV5/de/ndm8+/fv7++x8VPHj13anpAlABih/0y06XLL77Hxv4++//jN1PgQpQNAB9VrPy3h+gJDaw8cwbAzQNED2Hb3zAqqF0yV2gLJoGkDfc2y52bHzYt+Xx3P3Pn7z9AQ8o82pQuKNogOsBulW35LRu6eljNz/8+PX31vNvEROvAkMJPeLQkHXdOd+uy8F9V+3qzwPjBxHTgxIAAAw0OfX6IqO6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/AQ.png
// module id = 1076
// module chunks = 0